let React =            require("react");
const {  Route  } = require('react-router-dom');
let Application =      require("../Application.js");

let ExLibrary =        require("../controls/explore/ExploreLibraries.jsx");
let ExPackages =       require("../controls/explore/ExplorePackages.jsx");
let Ex3DModels =       require("../controls/explore/Explore3DModels.jsx");
let ExOverView =       require("../controls/explore/ExploreOverview.jsx");
let Cover       = require("../controls/Cover.jsx");
let HubModalManager = require("../controls/hub/modals/HubModalManager.jsx");

let SiteHeader =       require("../controls/SiteHeader.jsx");
let SubNavigationBar = require("../controls/SubNavigationBar.jsx");
let Footer =           require("../controls/Footer.jsx");
var MasterPage = require("./generic/MasterPage.jsx");


const SECTION_NAME = "explore";

class Search extends React.Component {

    constructor() {
        super();

        this.state = { valueSearch: {value: "", url: ""}, doingSearch: false, isLogin: false};

        this.onSearch = this.onSearch.bind(this);
        this.onSectionName = this.onSectionName.bind(this);
        this.setValueSearch = this.setValueSearch.bind(this);
        this.clearValueSearch = this.clearValueSearch.bind(this);
        this.clearSearch = this.clearSearch.bind(this);

    }

    componentDidMount() {
        Application.dataStore.getUserInfo().then(isLogin => this.setState({ isLogin }));
        this.setInfo(this.props, () => { this.setState({ valueSearch: {value: "", url: ""} }) });
    }

    componentWillReceiveProps(nextProps){
        this.setInfo(nextProps)
    }

    setInfo({ location }, chageState = () => {}){
        if(location.search && location.search.includes("?q=")){
            this.setState({ valueSearch: {url: this.formatQuery("?", location.search),
                value: this.formatQuery("?q=", location.search)},
                doingSearch: true});
        }else{
            chageState();
        }
    }

    onSearch(value){
        this.props.history.push(`/search?q=${value}`);
    }

    setValueSearch(valueSearch){
        googleGA("send", "event", "searching", "searchPage");
        this.setState({ valueSearch, doingSearch: true })
    }

    clearValueSearch(){
        const { valueSearch } = this.state;
        if(valueSearch.value){
            this.setState({ valueSearch: {url: `q=${valueSearch.value}`, value: valueSearch.value}});
        }
    }

    clearSearch(goingToPackages){
      if(location.pathname == '/search/packages' && goingToPackages) return;
      const { valueSearch } = this.state;

      //let url = (goingToPackages === true && !valueSearch.value)? `q=${valueSearch.value}&properties.ipc_family=16&hasVersions=true` : `q=${valueSearch.value}`;

      let url = (goingToPackages === true && !valueSearch.value)? `q=${valueSearch.value}` : `q=${valueSearch.value}`;
      this.setState({ valueSearch: {value: (valueSearch.value)? valueSearch.value: '', url: url}});

    }

    formatQuery(pather, query){
        if(query !== "") return query.replace(pather,"");
        return query;
    }

    onSectionName(sectionName){
        this.setState({ sectionName })
    }

    getConfig(){
        return { handleError: this.props.handleError, onSectionName: this.onSectionName, hasSearching: true, showNav: false, search: this.state.valueSearch, type: "Search"}
    }

    render() {

        const divStyle = {fontSize: '30px', marginTop: '40px', fontWeight: '600'};

        // its a unique thing about the explore pages that the search is a part of the subnav bar.
        // this requires us to duplicate some search data (query, page, etc)
        return (
            <MasterPage
                {...this.props}
                renderPage={masterPageProps =>
                    <HubModalManager
                        {...masterPageProps}
                        renderPage={addedProps =>
                            <div className="explore">
                                <SiteHeader type="Explore" onSearch={this.onSearch}/>
                                <Cover/>


                                <div className="container">
                                    <SubNavigationBar match={this.props.match} search={true}
                                                      setSearchValue={this.state.valueSearch.value}
                                                      onSetUrlLibraries={this.setValueSearch}
                                                      clearSearch={this.clearSearch}
                                    />
                                </div>


                                <Route exact path="/search" render={props =>
                                    <ExOverView {...props} {...this.getConfig()} {...addedProps}
                                                isLogin={this.state.isLogin}
                                    />}
                                />

                                <Route exact path='/search/libraries' render={props =>
                                    <ExLibrary {...props} {...this.getConfig()} {...addedProps}
                                               isLogin={this.state.isLogin}
                                               doingSearch={this.state.doingSearch}
                                    />}
                                />

                                <Route exact path="/search/packages" render={props =>
                                    <ExPackages {...props} {...this.getConfig()} {...addedProps}
                                                isLogin={this.state.isLogin}
                                                doingSearch={this.state.doingSearch}
                                                clearValueSearch={this.clearSearch}
                                    />}
                                />

                                <Route exact path="/search/3dmodels" render={props =>
                                    <Ex3DModels {...props} {...this.getConfig()} {...addedProps}
                                                isLogin={this.state.isLogin}
                                                doingSearch={this.state.doingSearch}
                                    />}
                                />

                                <Footer type={SECTION_NAME}/>
                            </div>
                        }
                    />
                }
            />
        )
    }
}

module.exports = Search;
